import { render, staticRenderFns } from "./AddMultaGlobal.vue?vue&type=template&id=7e8ce41f&"
import script from "./AddMultaGlobal.vue?vue&type=script&lang=js&"
export * from "./AddMultaGlobal.vue?vue&type=script&lang=js&"
import style0 from "./AddMultaGlobal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports